/**
 * @fileoverview Enum para las Comunidades Autónomas de España
 * @description Define las comunidades autónomas disponibles para selección en formularios
 */

/**
 * Enum de Comunidades Autónomas de España
 */
export enum ComunidadAutonoma {
  ANDALUCIA = 'Andalucía',
  ARAGON = 'Aragón',
  ASTURIAS = 'Asturias',
  ISLAS_BALEARES = 'Islas Baleares',
  CANARIAS = 'Canarias',
  CANTABRIA = 'Cantabria',
  CASTILLA_LA_MANCHA = 'Castilla-La Mancha',
  CASTILLA_Y_LEON = 'Castilla y León',
  CATALUNYA = 'Cataluña',
  EXTREMADURA = 'Extremadura',
  GALICIA = 'Galicia',
  LA_RIOJA = 'La Rioja',
  COMUNIDAD_MADRID = 'Comunidad de Madrid',
  REGION_MURCIA = 'Región de Murcia',
  NAVARRA = 'Navarra',
  PAIS_VASCO = 'País Vasco',
  COMUNIDAD_VALENCIANA = 'Comunidad Valenciana'
}

/**
 * Array de comunidades autónomas para uso en selects
 */
export const COMUNIDADES_AUTONOMAS: ComunidadAutonoma[] = [
  ComunidadAutonoma.ANDALUCIA,
  ComunidadAutonoma.ARAGON,
  ComunidadAutonoma.ASTURIAS,
  ComunidadAutonoma.ISLAS_BALEARES,
  ComunidadAutonoma.CANARIAS,
  ComunidadAutonoma.CANTABRIA,
  ComunidadAutonoma.CASTILLA_LA_MANCHA,
  ComunidadAutonoma.CASTILLA_Y_LEON,
  ComunidadAutonoma.CATALUNYA,
  ComunidadAutonoma.EXTREMADURA,
  ComunidadAutonoma.GALICIA,
  ComunidadAutonoma.LA_RIOJA,
  ComunidadAutonoma.COMUNIDAD_MADRID,
  ComunidadAutonoma.REGION_MURCIA,
  ComunidadAutonoma.NAVARRA,
  ComunidadAutonoma.PAIS_VASCO,
  ComunidadAutonoma.COMUNIDAD_VALENCIANA
];

